export class ReviewsSlider {

    constructor(options) {
        this.options = $.extend({
            node: $('.section--reviews-carousel .reviews--slider'),
            slickOptions: {
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                adaptiveHeight: true,
                arrows: false
            }
        }, options);

        this.options.node.slick(this.options.slickOptions);
    }

}

export class ReviewsSlider_v2 {
    constructor(options) {
        this.options = $.extend({
            node: $('.reviews--slider-v2'),
            slickOptions: {
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            adaptiveHeight: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        }, options);

        const slider = this.options.node;
        fixSlickFocus(slider);
        slider.slick(this.options.slickOptions);
        setTimeout(() => slider.trigger('setPosition'), 0);
    }
}


function fixSlickFocus(slider) {
    const applyFocus = () => {
        slider.find('.slick-slide')
            .attr('tabindex', '-1')
            .attr('aria-hidden', 'true')
            .find('.read-more, [role="button"], button, a, [tabindex]')
            .attr('tabindex', '-1');

        const $active = slider
            .find('.slick-slide.slick-current.slick-active')
            .not('.slick-cloned')
            .first();

        if (!$active.length) return;

        $active
            .attr('tabindex', '0')
            .attr('aria-hidden', 'false');

        $active.find('.read-more, [role="button"], button, a, [tabindex]')
            .attr('tabindex', '0');
    };

    slider.on('init reInit afterChange setPosition', () => {
        applyFocus();
        setTimeout(applyFocus, 0);
    });
}


